module.exports = __webpack_public_path__ + "static/map-6099813a9a62a36f6f1afa328e7ebcbd.webp";